import { AnonymousContentWrapper } from "@/components/wrappers/AnonymousContentWrapper";
import { setErrorsToForm } from "@/utils/formUtils";
import { validations } from "@/utils/validationUtils";
import { App as AntApp, Button, Col, Form, Input, Row } from "antd";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate, useParams, useSearchParams } from "react-router";
import { useResetPassword } from "../../../common/api/queries";
import { EntityIdObject } from "../../../common/types";
import { AUTH_ROUTE_PATHS } from "../../auth/paths";
import { DASHBOARD_ROUTE_PATHS } from "../../dashboard/paths";
import { PasswordReset } from "../types";

export const ResetPasswordContainer = () => {
  const { t } = useTranslation();
  const { modal } = AntApp.useApp();

  const { id } = useParams<EntityIdObject>() as { id: string };
  const navigate = useNavigate();

  const [urlParams] = useSearchParams();
  const token = urlParams.get("token");

  const [form] = Form.useForm<PasswordReset>();

  const resetPassword = useResetPassword();

  if (!token) {
    return <Navigate to={DASHBOARD_ROUTE_PATHS.homepage.to} replace />;
  }

  const handleFormFinish = (values: PasswordReset) => {
    resetPassword.mutate(
      { id, object: { ...values, token } },
      {
        onError: (error) => setErrorsToForm(form, "user.attrs", error.violations),
        onSuccess: () => {
          modal.success({
            title: t("common.operationSuccess"),
            content: t("user.helpers.resetPasswordSuccess"),
            okText: t("user.actions.continueToLogin"),
            onOk: () => navigate(AUTH_ROUTE_PATHS.login.to, { replace: true }),
          });
        },
      },
    );
  };

  return (
    <AnonymousContentWrapper>
      <h2 className="center-align margin-bottom-large">{t("user.titles.passwordReset")}</h2>

      <Row justify="center">
        <Col style={{ flex: "0 0 400px" }}>
          <Form form={form} layout="vertical" name="resetPasswordForm" onFinish={handleFormFinish}>
            <Form.Item name="password" label={t("user.attrs.password")} rules={validations.sufficientPassword}>
              <Input.Password />
            </Form.Item>

            <Form.Item
              name="passwordRepeat"
              label={t("user.attrs.passwordRepeat")}
              rules={[...validations.sufficientPassword, validations.repeatedPassword()]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item>
              <Button
                className="margin-top-medium"
                type="primary"
                htmlType="submit"
                block
                loading={resetPassword.isPending}
              >
                {t("user.actions.resetPassword")}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </AnonymousContentWrapper>
  );
};
